module.exports = __webpack_public_path__ + "img/LNB_register.831b1c36.svg";